import { useDealerQuery } from '@/features/dealers/hooks/useDealerQuery';
import { TextLink } from '@/shared/components';

interface Props {
    dealerId: string | null;
}

export function HomeDealerLink({ dealerId }: Props) {
    const query = useDealerQuery(dealerId ?? '', { suppressForbiddenToast: true });

    if (!dealerId) {
        return <span className="text-mp-muted">&mdash;</span>;
    }
    if (query.isLoading) {
        return <span className="text-mp-muted">Loading&hellip;</span>;
    }
    if (query.data?.name) {
        return (
            <TextLink to={`/admin/dealers/${dealerId}`} color="primary">
                {query.data.name}
            </TextLink>
        );
    }
    return (
        <span className="font-mono text-xs" title={dealerId}>
            {dealerId}
        </span>
    );
}
